import vuetify from "../vuetify";
import { vuetifyTextColorClasses, getOrCreateStyleBlock } from './css-generator'

const quilityColors = [
    'blue',
    'resources',
    'green',
    'leads',
    'new_b',
    'engagement',
    'support',
]

const colorSuffixes = {
    1: '-shade-2',
    2: '-shade-1',
    3: '',
    4: '-tint-1',
    5: '-tint-2',
}

export const setVuetifyTheme = (theme, dark = false) => {
    vuetify.framework.theme.dark = dark;
    Object.keys(theme).forEach(key => {
        vuetify.framework.theme.currentTheme[key] = theme[key];
    })


    // Quility colors overrides

    quilityColors.forEach(qColor => {
        Object.keys(colorSuffixes).forEach(suffixKey => {
            vuetify.framework.theme.currentTheme[`q_${qColor}_${suffixKey}`] = theme['primary' + colorSuffixes[suffixKey]]
        })
    })

    const css = vuetifyTextColorClasses(vuetify.framework.theme.currentTheme)

    getOrCreateStyleBlock('q-vuetify-class-helpers').innerHTML = css
}
